// src/MapaChales.js

import React, { useState, useEffect, useCallback } from 'react';
import { db } from './firebaseConfig';
// --- NOVA IMPORTAÇÃO ---
import { doc, deleteDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { toast } from 'react-toastify';
import './MapaChales.css';
import useReservasStore from './store/reservasStore';

// Modais
import ReservaModal from './ReservaModal';
import DetalhesReservaModal from './DetalhesReservaModal';

// Imports dos componentes MUI
import { 
    Box, Paper, Typography, CircularProgress, Button, Card, CardHeader, 
    CardContent, CardActions, Avatar, Divider, Tooltip, TextField, IconButton
} from '@mui/material';
import { green, red, orange, blue, yellow } from '@mui/material/colors';

// Imports dos Ícones MUI
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import BuildIcon from '@mui/icons-material/Build';
import PaidIcon from '@mui/icons-material/Paid';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
// --- NOVO ÍCONE ---
import SearchIcon from '@mui/icons-material/Search';


const getHojeFormatado = () => {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = (hoje.getMonth() + 1).toString().padStart(2, '0');
  const dia = hoje.getDate().toString().padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
};

const ConfirmacaoToast = ({ closeToast, onConfirm, message }) => (
    <div>
      <p>{message}</p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
        <Button size="small" variant="contained" color="error" onClick={() => { onConfirm(); closeToast(); }}>Sim</Button>
        <Button size="small" variant="outlined" color="inherit" onClick={closeToast}>Não</Button>
      </div>
    </div>
);

const formatarDataBr = (dataString) => {
  if (!dataString) return '--/--/----';
  const [ano, mes, dia] = dataString.split('-');
  return `${dia}/${mes}/${ano}`;
};

const LegendaCores = () => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2, justifyContent: 'center', borderTop: '1px solid #eee', pt: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 20, height: 20, backgroundColor: blue[500], borderRadius: '4px' }} /><Typography variant="caption">Hospedado</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 20, height: 20, backgroundColor: green[500], borderRadius: '4px' }} /><Typography variant="caption">Pago Total</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 20, height: 20, backgroundColor: red[500], borderRadius: '4px' }} /><Typography variant="caption">Pago Sinal</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 20, height: 20, backgroundColor: yellow[700], borderRadius: '4px' }} /><Typography variant="caption">Aguardando Pag.</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 20, height: 20, backgroundColor: orange[500], borderRadius: '4px' }} /><Typography variant="caption">Em Limpeza</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 20, height: 20, backgroundColor: orange[900], borderRadius: '4px' }} /><Typography variant="caption">Manutenção</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 20, height: 20, backgroundColor: green[100], borderRadius: '4px', border: '1px solid #ccc' }} /><Typography variant="caption">Livre</Typography></Box>
  </Box>
);


const MapaChales = () => {
  const { 
    reservas, 
    chales, 
    manutencoes,
    loading, 
    fetchInitialData,
    liberarChale
  } = useReservasStore();

  const [statusChales, setStatusChales] = useState({});
  const [modalReservaAberto, setModalReservaAberto] = useState(false);
  const [modalDetalhesAberto, setModalDetalhesAberto] = useState(false);
  const [chaleSelecionado, setChaleSelecionado] = useState(null);
  const [reservaSelecionada, setReservaSelecionada] = useState(null);
  const [reservaParaEditar, setReservaParaEditar] = useState(null);
  // --- NOVO ESTADO PARA O CAMPO DE BUSCA ---
  const [termoBuscaVoucher, setTermoBuscaVoucher] = useState('');


  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);
  
  const calcularStatusChale = useCallback(() => {
    if (loading || chales.length === 0) return;

    const hoje = getHojeFormatado();
    const statusInicial = {};

    chales.forEach(chale => {
        statusInicial[chale.numero] = { status: 'Livre', chale };
    });

    manutencoes.forEach(manutencao => {
        if (hoje >= manutencao.dataInicio && hoje <= manutencao.dataFim) {
            const numeroChale = manutencao.chaleNumero;
            if (statusInicial[numeroChale]) {
                statusInicial[numeroChale] = { 
                    status: 'Manutenção', 
                    chale: chales.find(c => c.numero === numeroChale),
                    motivo: manutencao.motivo 
                };
            }
        }
    });

    chales.forEach(chale => {
        if (chale.status === 'Em Limpeza' && statusInicial[chale.numero].status !== 'Manutenção') {
            statusInicial[chale.numero].status = 'Em Limpeza';
        }
    });

    const reservasAtivas = (reservas || []).filter(r => r.dataCheckin <= hoje && r.dataCheckout > hoje);
    reservasAtivas.forEach(reserva => {
        if (statusInicial[reserva.chaleNumero] && statusInicial[reserva.chaleNumero].status !== 'Manutenção') {
            let statusFinal = 'Ocupado';
            
            const valorTotal = reserva.valorTotal || 0;
            const totalPago = (reserva.adiantamento?.valor || 0) + (reserva.pagamentoRestante?.valor || 0);
            const saldoDevedor = valorTotal - (reserva.desconto || 0) - totalPago;

            if (reserva.statusReserva === 'Hospedado') {
                statusFinal = 'Hospedado';
            } else if (reserva.statusReserva === 'Confirmada' || reserva.statusReserva === 'Pago Total') {
                if (saldoDevedor <= 0 || reserva.statusReserva === 'Pago Total') {
                    statusFinal = 'PagoTotal';
                } else if (reserva.adiantamento?.valor > 0) {
                    statusFinal = 'PagoParcial';
                } else {
                    statusFinal = 'AguardandoPagamento';
                }
            }
            
            statusInicial[reserva.chaleNumero].status = statusFinal;
            statusInicial[reserva.chaleNumero].reserva = reserva;
        }
    });
    
    setStatusChales(statusInicial);
  }, [reservas, chales, manutencoes, loading]);


  useEffect(() => {
    calcularStatusChale();
  }, [calcularStatusChale]);
  
  const handleChaleClick = (statusInfo) => {
    if (statusInfo.status === 'Livre') {
      setChaleSelecionado(statusInfo.chale);
      setModalReservaAberto(true);
    } else if (statusInfo.reserva) {
      setReservaSelecionada(statusInfo.reserva);
      setModalDetalhesAberto(true);
    } else if (statusInfo.status === 'Manutenção') {
      toast.info(`Este chalé está em manutenção. Motivo: ${statusInfo.motivo}`);
    } else if (statusInfo.status === 'Em Limpeza') {
      toast.info(`Este chalé está em processo de limpeza.`);
    }
  };
  
  const handleLiberarChale = (chaleId, chaleNumero) => {
    const doRelease = () => {
      liberarChale(chaleId);
    };
    toast.info(
      <ConfirmacaoToast
        onConfirm={doRelease}
        message={`Deseja realmente liberar o Chalé ${chaleNumero} e torná-lo disponível?`}
      />, { autoClose: false, closeOnClick: false }
    );
  };

  // --- NOVA FUNÇÃO PARA BUSCAR RESERVA PELO VOUCHER ---
  const handleBuscarVoucher = async () => {
    if (!termoBuscaVoucher.trim()) {
        toast.info('Por favor, digite um código de voucher para buscar.');
        return;
    }
    try {
        const reservasRef = collection(db, 'reservas');
        const q = query(reservasRef, where('codigoVoucher', '==', termoBuscaVoucher.trim().toUpperCase()));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            toast.error('Nenhuma reserva encontrada com este código de voucher.');
        } else {
            const reservaEncontrada = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
            setReservaSelecionada(reservaEncontrada);
            setModalDetalhesAberto(true);
            setTermoBuscaVoucher(''); // Limpa o campo após a busca
        }
    } catch (error) {
        toast.error('Ocorreu um erro ao buscar a reserva.');
        console.error("Erro ao buscar voucher:", error);
    }
  };
  
  const fecharModalDetalhes = () => { setModalDetalhesAberto(false); setReservaSelecionada(null); };
  const fecharModalReserva = () => { setModalReservaAberto(false); setChaleSelecionado(null); setReservaParaEditar(null); fetchInitialData(); };
  const handleEditarReserva = (reserva) => { fecharModalDetalhes(); setReservaParaEditar(reserva); setChaleSelecionado(chales.find(c => c.id === reserva.chaletId)); setModalReservaAberto(true); };
  const handleExcluirReserva = (reservaId) => {
     const deletar = async () => {
        try {
            await deleteDoc(doc(db, "reservas", reservaId));
            toast.success("Reserva excluída com sucesso!");
            fecharModalDetalhes();
            fetchInitialData();
        } catch (error) { toast.error("Erro ao excluir reserva."); }
     };
     toast.warn(<ConfirmacaoToast message="Tem certeza que deseja excluir esta reserva?" onConfirm={deletar}/>, { position: "top-center", autoClose: false, closeOnClick: false });
  };
  
  const renderChaleCard = (chale) => {
    if (!chale || !chale.numero) return null;
    const statusInfo = statusChales[chale.numero] || { status: 'Indefinido', chale };
    let statusIcon, statusColor, statusSubheader;

    switch (statusInfo.status) {
      case 'Livre': statusIcon = <EventAvailableIcon />; statusColor = green[100]; statusSubheader = 'Disponível para reserva'; break;
      case 'Hospedado': statusIcon = <PersonOffIcon />; statusColor = blue[500]; statusSubheader = 'HOSPEDADO - Check-out em ' + formatarDataBr(statusInfo.reserva?.dataCheckout); break;
      case 'PagoTotal': statusIcon = <PaidIcon />; statusColor = green[500]; statusSubheader = 'PAGO TOTAL - Aguardando Check-in'; break;
      case 'PagoParcial': statusIcon = <PaidIcon />; statusColor = red[500]; statusSubheader = 'PAGO SINAL - Aguardando Check-in'; break;
      case 'AguardandoPagamento': statusIcon = <HourglassEmptyIcon />; statusColor = yellow[700]; statusSubheader = 'AGUARDANDO PAGAMENTO'; break;
      case 'Manutenção': statusIcon = <BuildIcon />; statusColor = orange[900]; statusSubheader = 'Indisponível'; break;
      case 'Em Limpeza': statusIcon = <CleaningServicesIcon />; statusColor = orange[500]; statusSubheader = 'Em Limpeza'; break;
      default: statusIcon = <MeetingRoomIcon />; statusColor = 'grey.500'; statusSubheader = 'Status desconhecido';
    }

    return (
      <Card 
        key={chale.id} 
        sx={{ gridArea: `chale-${chale.numero}`, display: 'flex', flexDirection: 'column', height: '100%' }}
        elevation={3}
      >
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: statusColor, color: statusInfo.status === 'Livre' ? 'black' : 'white' }} aria-label="status">{statusIcon}</Avatar>}
          title={<Typography variant="h6" fontWeight="bold">{chale.nome}</Typography>}
          subheader={statusSubheader}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Divider sx={{ mb: 2 }} />
          {statusInfo.status === 'Livre' && ( <Typography variant="body2" color="text.secondary">Capacidade: {chale.capacidadePadrao} pessoas.</Typography> )}
          {(statusInfo.reserva) && ( <Typography variant="body2" color="text.secondary"><strong>Hóspede:</strong> {statusInfo.reserva?.hospedeNome}</Typography> )}
          {statusInfo.status === 'Manutenção' && ( <Typography variant="body2" color="text.secondary"><strong>Motivo:</strong> {statusInfo.motivo || 'Não especificado'}</Typography> )}
        </CardContent>
        <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
            {statusInfo.status === 'Livre' && (
                <Button variant="contained" size="small" onClick={() => handleChaleClick(statusInfo)}>Reservar</Button>
            )}
            {statusInfo.reserva && (
                <Button variant="contained" size="small" onClick={() => handleChaleClick(statusInfo)}>Ver Detalhes</Button>
            )}
             {statusInfo.status === 'Manutenção' && (
                <Button variant="contained" disabled size="small">Ver Detalhes</Button>
            )}
            {statusInfo.status === 'Em Limpeza' && (
              <Tooltip title="Marcar chalé como limpo e disponível">
                <Button 
                  variant="contained" 
                  color="warning" 
                  size="small" 
                  onClick={() => handleLiberarChale(chale.id, chale.numero)}
                >
                  Liberar
                </Button>
              </Tooltip>
            )}
        </CardActions>
      </Card>
    );
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Carregando status dos chalés...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      <Paper sx={{ p: 2, mb: 3, width: '100%', maxWidth: '1400px' }}>
        <Typography variant="h5" fontWeight="600">
          Mapa do Dia ({new Date().toLocaleDateString('pt-BR')})
        </Typography>
        <Typography color="text.secondary">
          Layout físico dos chalés e seu status de ocupação atual.
        </Typography>
        
        {/* --- CAMPO DE BUSCA ADICIONADO AQUI --- */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2, borderTop: '1px solid #eee', pt: 2 }}>
            <TextField
                label="Buscar reserva por Voucher..."
                variant="outlined"
                size="small"
                value={termoBuscaVoucher}
                onChange={(e) => setTermoBuscaVoucher(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleBuscarVoucher()}
                sx={{ flexGrow: 1, maxWidth: '400px' }}
            />
            <Tooltip title="Buscar">
                <IconButton color="primary" onClick={handleBuscarVoucher}>
                    <SearchIcon />
                </IconButton>
            </Tooltip>
        </Box>
        
        <LegendaCores />
      </Paper>

      <div className="mapa-chales-grid">
        {(chales || []).map(chale => renderChaleCard(chale))}
      </div>
      
      {modalDetalhesAberto && (
        <DetalhesReservaModal 
          reserva={reservaSelecionada} 
          onClose={fecharModalDetalhes} 
          onExcluir={handleExcluirReserva} 
          onEditar={handleEditarReserva} 
        />
      )}
      
      {modalReservaAberto && (
        <ReservaModal 
          chale={reservaParaEditar ? chales.find(c => c.id === reservaParaEditar.chaletId) : chaleSelecionado} 
          onClose={fecharModalReserva} 
          reservaParaEditar={reservaParaEditar}
          checkinPadrao={getHojeFormatado()}
        />
      )}
    </Box>
  );
};

export default MapaChales;

